<div class="card-body" style="height: 363px;">
    <canvas id="{{chartId}}"></canvas>
</div>
